module.exports = __webpack_public_path__ + "img/collection-engagementRingsEssentials.07cc497.webp";